import React, { useContext } from 'react'

// styles
import { useAuth0 } from '@auth0/auth0-react'
import { useAuthParams } from '@/components/pages/auth/hooks/authParams'
import { LoaderRedirectPage } from '@/components/pages/loader_redirecting'
import { MainLayoutV2 } from '@/layouts/MainLayoutV2'
import { UserContext } from 'context'
import { useRouter } from 'next/router'

const Signup: React.FC = () => {
  const router = useRouter()
  const { loginWithRedirect, isLoading, isAuthenticated } = useAuth0()
  const { storeUrlParams } = useAuthParams()
  const { user, loading } = useContext(UserContext)

  React.useEffect(() => {
    const login = async () => {
      await storeUrlParams()
      loginWithRedirect({
        authorizationParams: {
          screen_hint: 'login',
        },
      })
    }
    if (isLoading || loading) return

    if (!isAuthenticated || !user?.id || !user?.is_complete) {
      login()
    } else {
      if (router?.query?.urlCallback) {
        let url = router?.query?.urlCallback as string
        url += router?.query?.requestConnection ? '?requestConnection=true' : ''
        router.push(url)
        return
      }
      router.push(`/${user.username.toLocaleLowerCase()}`)
    }
  }, [
    isLoading,
    isAuthenticated,
    loading,
    loginWithRedirect,
    router,
    user,
    storeUrlParams,
  ])

  return (
    <MainLayoutV2>
      <LoaderRedirectPage />
    </MainLayoutV2>
  )
}

export default Signup
